import { useState, useEffect } from "react";
import store from "./store/store";
import { ThemeProvider } from "styled-components";
import { GlobalStyle, palatte } from "./theme";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./pages/Login";
import PatientList from "./pages/PatientList";
import Viewer from "./pages/Viewer";
import Summary from "./pages/Summary";
import { fetchCheckSession } from "./api/userApi";

const App = () => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const token = useSelector((state) => state.UserDetailsReducer.token);

  //세션 시간 체크
  useEffect(() => {
    const checkSession = async () => {
      setIsLoading(true);
      try {
        // 로컬 스토리지에서 토큰 확인
        const userDetails = localStorage.getItem("luca_userDetails");
        if (userDetails) {
          const parsedDetails = JSON.parse(userDetails);
          if (parsedDetails.token) {
            setIsUserAuthenticated(true);
            setIsLoading(false);
            return;
          }
        }

        // 서버 세션 체크
        const data = await fetchCheckSession();
        if (data !== "" && data !== null) {
          setIsUserAuthenticated(true);
        } else {
          setIsUserAuthenticated(false);
        }
      } catch (error) {
        console.error("세션 체크 오류:", error);
        setIsUserAuthenticated(false);
      }
      setIsLoading(false);
    };
    checkSession();
  }, [token]);

  // 토큰이 변경될 때마다 인증 상태 업데이트
  useEffect(() => {
    if (token) {
      setIsUserAuthenticated(true);
    }
  }, [token]);

  // 로컬 스토리지 변경 감지
  useEffect(() => {
    const handleStorageChange = () => {
      const userDetails = localStorage.getItem("luca_userDetails");
      if (userDetails) {
        const parsedDetails = JSON.parse(userDetails);
        if (parsedDetails.token) {
          setIsUserAuthenticated(true);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const ProtectedRoute = ({ children }) => {
    if (isLoading) {
      return <div>Loading...</div>;
    }
    if (!isUserAuthenticated) {
      return <Navigate to="/" />;
    }
    return children;
  };

  // Viewer, Summary 페이지에서 어떤 환자 정보를 들고 올지 알아야 하기 때문에
  // store에서 user_seq, patient_seq를 들고 와서 알맞는 path로 간다.
  const patientDetails = useSelector((state) => state.PathDetailsReducer);

  return (
    <ThemeProvider theme={palatte}>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route
            exact
            path="/PatientList"
            element={
              <ProtectedRoute>
                <PatientList />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/Viewer/:user_seq/:patient_seq"
            element={
              <ProtectedRoute>
                <Viewer
                  key={`${patientDetails.user_seq_store}-${patientDetails.patient_seq_store}`}
                />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/Summary/:user_seq/:patient_seq"
            element={
              <ProtectedRoute>
                <Summary />
              </ProtectedRoute>
            }
          />
          {/* Catch-all route for 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
